import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import Footer from "../components/Footer";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import trueSquare from "../assets/images/truesquare.png";

import _ from "lodash";
import numeral from "numeral";
import Modal from "@material-ui/core/Modal";
import Loading from "../components/Loading";
import Icon from "@material-ui/core/Icon";
import moment from "moment";

import { createOrder, getOtp } from "../api";
import { dispatch } from "../store";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  contentHeader: {
    borderTop: "1px solid #dee1e9",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.08)"
  },
  contentHeaderOpen: {
    borderTop: "1px solid #dee1e9",
    boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.08)"
  },
  contentHeaderTitle: {
    ...fontDefault,
    color: "#333333",
    fontSize: "16px",
    fontWeight: "bold"
  },
  contentHeaderSemiTitle: {
    ...fontDefault,
    color: "#4a4a4a",
    fontSize: "14px"
  },
  contentHeaderSubTitle: {
    ...fontDefault,
    color: "rgb(135 139 150)",
    fontSize: "14px"
  },
  contentHeaderSubPrice: {
    ...fontDefault,
    color: "#4a4a4a",
    fontSize: "14px",
    fontFamily: "San Francisco Text"
  },
  contentHeaderPrice: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    color: "#333333",
    fontSize: "16px",
    fontWeight: "bold"
  },
  container: {
    margin: "16px"
  },
  contentDesc: {
    ...fontDefault,
    color: "#0e162c",
    fontSize: "14px",
    marginTop: "16px",
    display: "block"
  },

  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  text: {
    ...fontDefault,
    color: "#878B96",
    fontSize: "14px"
  },
  textBold: {
    ...fontDefault,
    color: "#878B96",
    fontSize: "14px",
    fontWeight: "bold"
  },
  line: {
    border: "0.5px solid #878B96"
  },
  blueLine: {
    border: "0.5px solid #328DF5"
  },
  paymentContainer: {
    marginTop: "16px",
    backgroundColor: "white",
    borderRadius: "8px",
    border: "1px solid #118df5",
    padding: "16px",
    cursor: "pointer"
  },
  paymentContainerActive: {
    backgroundColor: "white",
    borderRadius: "8px",
    border: "1px solid #328DF5",
    padding: "15px"
  },
  paymentHeader: {
    display: "flex",
    alignItems: "center"
  },
  paymentImage: {
    width: "50px",
    height: "50px",
    borderRadius: "50px",
    border: "1px solid #ededed",
    padding: "5px"
  },
  paymentTitleContainer: {
    marginLeft: "15px"
  },
  paymentTitle: {
    ...fontDefault,
    color: "#0e162c",
    fontSize: "16px",
    margin: "0px"
  },
  paymentTitleDetail: {
    ...fontDefault,
    color: "#878b96",
    fontSize: "14px",
    margin: "0px"
  },
  paymentContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "6px"
  },
  paymentPrice: {
    ...fontDefault,
    fontSize: "24px",
    color: "#0B0A0A"
  },
  paymentPriceActive: {
    ...fontDefault,
    fontSize: "24px",
    color: "#328DF5"
  },
  paymentPriceText: {
    ...fontDefault,
    fontSize: "14px",
    color: "#979797"
  }
};

const dateStringToText = (inputdate = "0001-01-01") => {
  const date = new Date(inputdate + "T07:00:00");
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear() + 543).slice(-2);
  return day + "/" + month + "/" + year;
};

function trimIfPossible(text) {
  try {
    const newText = text.trim();
    if (newText === "-") {
      return "";
    } else {
      return newText;
    }
  } catch (error) {
    return text;
  }
}

class PaymentPlan extends Component {
  state = {
    isLoading: false,
    isExpand: false
  };

  goToNextPage = async () => {
    const { auth = {} } = this.props;
    const { token, userInput, selectedPackage = {}, moreAddress = {} } = auth;
    const {
      effDate,
      profiter,
      profiterRelation,
      profiterGender,
      profiterFirstName,
      profiterLastName,
      chiTravel,
      tax,
      address = "",
      homeNo = "",
      moo = "",
      building = "",
      soi = "",
      road = ""
    } = userInput;
    //let sumAddress = "";
    //sumAddress = address + " " + _.get(moreAddress, "fullAddress", "");
    const requestData = {
      package_id: _.get(selectedPackage, "id", 0),
      assurer: {
        email: _.get(userInput, "email", ""),
        phone_number: _.get(userInput, "phoneNumber", ""),
        id_card: _.get(userInput, "ID", "")
          .split("-")
          .join(""),
        title: _.get(userInput, "gender", ""),
        firstname_th: _.get(userInput, "firstName", ""),
        lastname_th: _.get(userInput, "lastName", ""),
        date_of_birth: moment(_.get(userInput, "birthdate", "")).toDate(),
        weight: parseFloat(_.get(userInput, "weight", "")) || 0,
        height: parseFloat(_.get(userInput, "height", "")) || 0,
        house_no: trimIfPossible(homeNo),
        moo: trimIfPossible(moo) || "",
        address_name: trimIfPossible(building) || "",
        soi: trimIfPossible(soi) || "",
        road: trimIfPossible(road) || "",
        sub_district: _.get(moreAddress, "subdistrict.name", ""),
        district: _.get(moreAddress, "district.name", ""),
        province: _.get(moreAddress, "province.jw_name", ""),
        post_code: _.get(moreAddress, "subdistrict.zipcode", ""),
        beneficiary: {
          relationship: profiter === "relation" ? "ทายาทตามกฏหมาย" : "อื่นๆ"
        }
      },
      coverage_from: moment(effDate).toDate(),
      coverage_to: moment(effDate)
        .add(1, "years")
        .subtract(1, "days")
        .toDate(),
      //address_deliver: sumAddress,
      recieve_policy_by: "email",
      additional_detail: {
        travel_to_chinese: false, //chiTravel === "yes",
        tax_exemption: tax === "yes"
      }
    };
    if (profiter === "other") {
      requestData.assurer.beneficiary["relationship"] = profiterRelation;
      requestData.assurer.beneficiary["title"] = profiterGender;
      requestData.assurer.beneficiary["firstname_th"] = profiterFirstName;
      requestData.assurer.beneficiary["lastname_th"] = profiterLastName;
    }

    this.setState({
      isLoading: true
    });
    try {
      const response = await createOrder(token, requestData);
      dispatch({ type: "", successOrder: response });
      const otpResponse = await getOtp(token);
      dispatch({ type: "", successOTP: otpResponse });
      this.setState({
        isLoading: false
      });
      const mixpanel = _.get(window, "mixpanel", undefined);
      if (!!mixpanel) {
        mixpanel.track("Insurance Corona Payment", {
          Insurer: "Dhipaya",
          "Insurance type": "Dhipaya Corona",
          "Insurance package": selectedPackage.name,
          Amount: selectedPackage.total_prem
        });
      }
      const {
        history: { push }
      } = this.props;
      push("/verify-otp");
      document.getElementById("rootScreen").scrollTo(0, 0);
    } catch (error) {
      this.setState({
        isLoading: false
      });
      dispatch({ type: "", isShowError: true, errorMessage: error.message });
      if (error.message === "Network Error") {
        const mixpanel = _.get(window, "mixpanel", undefined);
        if (!!mixpanel) {
          mixpanel.track("Insurance Corona Error", {
            "Insurance type": "Dhipaya Corona",
            Insurer: "Dhipaya",
            "Error message": "Payment-" + error.message,
            "Error code": "E10100"
          });
        }
        const dataLayer = _.get(window, "dataLayer", undefined);
        if (!!dataLayer) {
          dataLayer.push({
            event: "error-page", // Required
            errorMsg: "Payment-" + error.message
          });
        }
        const {
          history: { push }
        } = this.props;
        push("/error-common");
        document.getElementById("rootScreen").scrollTo(0, 0);
        return;
      }
      const response = _.get(error, "response", {});
      const responseStatus = response.status;

      if (
        responseStatus === 500 ||
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        const mixpanel = _.get(window, "mixpanel", undefined);
        if (!!mixpanel) {
          mixpanel.track("Insurance Corona Error", {
            "Insurance type": "Dhipaya Corona",
            Insurer: "Dhipaya",
            "Error message":
              "Payment-" +
              _.get(
                response,
                "message",
                "Create Order - Unknown error - " +
                  responseStatus +
                  " " +
                  _.get(error, "message", "")
              ),
            "Error code": "E10101"
          });
        }
        const dataLayer = _.get(window, "dataLayer", undefined);
        if (!!dataLayer) {
          dataLayer.push({
            event: "error-page", // Required
            errorMsg:
              "Payment-" +
              _.get(
                response,
                "message",
                "Create Order - Unknown error - " +
                  responseStatus +
                  " " +
                  _.get(error, "message", "")
              )
          });
        }
        const {
          history: { push }
        } = this.props;
        push("/error-common");
        document.getElementById("rootScreen").scrollTo(0, 0);
        return;
      }
    }
  };

  backButton = () => {
    const {
      history: { push }
    } = this.props;
    push("/agreement");
  };

  render() {
    const { classes, auth } = this.props;
    const { isLoading } = this.state;
    const { selectedPackage = {}, userInput = {}, user = {} } = auth;
    const balance = _.get(user, "balance", 0);
    const { total_prem = 0, display_name_th = "" } = selectedPackage;
    const { effDate } = userInput;
    return (
      <Wrapper>
        <Body style={{ backgroundColor: "white" }}>
          <div className={classes.contentHeaderOpen}>
            <div
              style={{
                padding: "16px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <span className={classes.contentHeaderTitle}>
                ประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อ ไวรัสโคโรนา
              </span>
            </div>
            <div
              style={{
                padding: "0px 16px 16px 16px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <span
                className={classes.contentHeaderSubTitle}
                style={{ color: "rgb(14 22 44)" }}
              >
                {display_name_th}
              </span>
            </div>
            <div
              style={{
                padding: "16px 16px 16px 16px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <span className={classes.contentHeaderSubTitle}>
                วันที่คุ้มครอง
              </span>
              <span className={classes.contentHeaderSubPrice}>
                {moment(effDate)
                  .toDate()
                  .toLocaleDateString("th-TH", {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                  })}
              </span>
            </div>
            <div
              style={{
                padding: "0px 16px 16px 16px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <span className={classes.contentHeaderSubTitle}>
                วันสิ้นสุดคุ้มครอง
              </span>
              <span className={classes.contentHeaderSubPrice}>
                {moment(effDate)
                  .add(1, "years")
                  .subtract(1, "days")
                  .toDate()
                  .toLocaleDateString("th-TH", {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                  })}
              </span>
            </div>
            <hr
              style={{
                borderTop: "1px solid #dee1e9",
                borderBottom: "none",
                marginLeft: "16px",
                marginRight: "16px"
              }}
            />
            <div
              style={{
                padding: "16px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <span className={classes.contentHeaderTitle}>ยอดชำระ</span>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className={classes.contentHeaderPrice}>
                  ฿ {numeral(parseFloat(total_prem)).format("0,0.00")}
                </span>
              </div>
            </div>
          </div>
          <div className={classes.container}>
            <span className={classes.contentHeaderTitle}>ช่องทางชำระเงิน</span>
            <div
              className={classes.paymentContainer}
              onClick={() => {
                this.setState({
                  isActive: true
                });
              }}
            >
              <div className={classes.paymentHeader}>
                <div
                  style={{
                    padding: "3px",
                    borderRadius: "50%",
                    border: "1px solid #118df5",
                    marginRight: "16px"
                  }}
                >
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#118df5"
                    }}
                  />
                </div>
                <img
                  alt="True Money Wallet"
                  src={trueSquare}
                  className={classes.paymentImage}
                />
                <div className={classes.paymentTitleContainer}>
                  <p className={classes.paymentTitle}>ทรูมันนี่ วอลเล็ท</p>
                  <p className={classes.paymentTitleDetail}>
                    ยอดเงินคงเหลือ{" "}
                    {numeral(parseFloat(balance || 0) / 100).format("0,0.00")}{" "}
                    บาท
                  </p>
                </div>
              </div>
              {total_prem > parseFloat(balance || 0) / 100 && (
                <div>
                  <div
                    className={classes.paymentHeader}
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      style={{
                        padding: "3px",
                        borderRadius: "50%",
                        border: "1px solid #118df5",
                        marginRight: "16px",
                        opacity: 0
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#118df5"
                        }}
                      />
                    </div>
                    <div
                      className={classes.paymentTitleContainer}
                      style={{ marginLeft: "0px", width: "100%" }}
                    >
                      <hr
                        style={{
                          borderTop: "1px solid #dee1e9",
                          borderBottom: "none"
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={classes.paymentHeader}
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      style={{
                        padding: "3px",
                        borderRadius: "50%",
                        border: "1px solid #118df5",
                        marginRight: "16px",
                        opacity: 0
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "4px",
                          backgroundColor: "#118df5"
                        }}
                      />
                    </div>
                    <div
                      className={classes.paymentTitleContainer}
                      style={{ marginLeft: "0px", display: "flex" }}
                    >
                      <p
                        className={classes.paymentTitle}
                        style={{ fontSize: "14px", color: "rgb(255 77 79)" }}
                      >
                        ยอดเงินไม่เพียงพอกรุณาเติมเงินเข้าวอลเล็ต
                      </p>
                      <button
                        style={{
                          backgroundColor: "rgb(255 131 0)",
                          border: "none",
                          height: "fit-content",
                          borderRadius: "20px",
                          padding: "3px 9px",
                          whiteSpace: "nowrap",
                          marginLeft: "16px"
                        }}
                        onClick={() => {
                          window.location.replace(
                            "ascendmoney://wallet.truemoney.co.th/app/660000000004?type=topup"
                          );
                        }}
                      >
                        <span
                          style={{
                            ...fontDefault,
                            fontSize: "16px",
                            color: "white",
                            fontWeight: "bold"
                          }}
                        >
                          +
                        </span>
                        <span
                          style={{
                            ...fontDefault,
                            fontSize: "14px",
                            color: "white",
                            marginLeft: "4px"
                          }}
                        >
                          เติมเงิน
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <Loading />
          </Modal>
        </Body>
        <Footer style={{ backgroundColor: "white" }}>
          <SubmitButton
            onClick={
              total_prem > parseFloat(balance || 0) / 100
                ? () => {}
                : this.goToNextPage
            }
            margin={true}
            disabled={total_prem > parseFloat(balance || 0) / 100}
          >
            ชำระเงิน
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              ยืนยันการทำรายการ
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, "motor.userInput", {}),
    balance: _.get(state, "auth.balance", 0),
    auth: _.get(state, "auth", {}),
    selectPrice: _.get(state, "motor.userInput.selectPrice", 0),
    currentProduct: _.get(state, "motor.userInput.currentProduct", "")
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: "USER_INPUT",
        data
      });
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PaymentPlan));
